export default __webpack_public_path__ + "locales/az/Files.json?hash=406534e07a34cd099ba8c510862107e7";